import { SHOW_BLOCKER, HIDE_BLOCKER } from '../actions/blocker';

const stack = [];

const Blocker = (state, { type, payload }) => {
    state || (state = {});

    switch (type) {
        case SHOW_BLOCKER:
            stack.push(null);
            break;
        case HIDE_BLOCKER:
            stack.pop();
            break;
        default:
            break;
    }

    return { ...state, block: !!stack.length };
}

export default Blocker;